import { useFormikContext } from 'formik';

import { VariableDefinition } from '../../custom-templates/components/CustomTemplatesVariablesDefinitionField';
import {
  getTemplateVariables,
  intersectVariables,
  isTemplateVariablesEnabled,
} from '../../custom-templates/components/utils';

interface FormValues {
  FileContent: string;
  Variables: VariableDefinition[];
}

export function useParseTemplateOnFileChange(
  oldVariables: VariableDefinition[]
) {
  const { setValues, setFieldError } = useFormikContext<FormValues>();

  return handleChangeFileContent;

  async function handleChangeFileContent(value: string) {
    const { variables, error } = parseTemplate(value);

    await setValues((values) => ({
      ...values,
      FileContent: value,
      Variables: variables,
    }));

    if (error) {
      setFieldError('FileContent', `Template invalid: ${error}`);
    }
  }

  function parseTemplate(value: string): {
    variables: VariableDefinition[];
    error?: string;
  } {
    if (!isTemplateVariablesEnabled || value === '') {
      return { variables: [] };
    }

    const [variables, validationError] = getTemplateVariables(value);

    if (!variables) {
      return { variables: oldVariables, error: validationError };
    }

    return { variables: intersectVariables(oldVariables, variables) };
  }
}
